import Actions                           from 'Redux/Actions';
import { EventParentCategoryRepository } from 'Domain/Repositories';
import { ofType }                        from 'redux-observable';
import { from, EMPTY }                   from 'rxjs';
import { mergeMap }                      from 'rxjs/operators';
import { TEpic }                         from 'Redux/Config';

export const findEventParentCategoryEpic: TEpic = (action$) => {
  return action$.pipe(
    ofType(Actions.findEventParentCategoryRequest.type),
    mergeMap(action => {
      const { id } = action.payload;

      if (!id.trim()) {
        return EMPTY;
      }

      return from(
        EventParentCategoryRepository.findById(id)
          .then((eventParentCategory) => Actions.findEventParentCategorySuccess({ eventParentCategory }))
          .catch(error => Actions.findEventParentCategoryFailure({ error })),
      );
    }),
  );
};
